import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

function getLocalStorage(): Storage {
  return localStorage;
}

@Injectable({ providedIn: 'root' })
export class LocalStorageRefService {
  get localStorage(): Storage {
    return getLocalStorage();
  }
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private _localStorage: Storage;
  private _data$ = new BehaviorSubject<any>(null);
  public data$ = this._data$.asObservable();

  constructor(private _localStorageRefService: LocalStorageRefService) {
    this._localStorage = _localStorageRefService.localStorage;
  }

  setInfo(keyName: string, data: any) {
    const jsonData = JSON.stringify(data);
    this._localStorage.setItem(keyName, jsonData);
    this._data$.next(data);
  }

  getInfo(keyName: string) {
    let storageData: any = this._localStorage.getItem(keyName);
    const data = JSON.parse(storageData);
    this._data$.next(data);
  }
}
